import classNames from 'classnames';
import {ComponentProps, FC, PropsWithChildren} from 'react';
import styles from './MeinChip.module.css';

export const MeinChip: FC<PropsWithChildren<ComponentProps<'div'>>> = ({
    children,
    className,
}) => {
    return <div className={classNames(styles.chip, className)}>{children}</div>;
};
